/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, May 13th 2024, 2:05:25 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
import { EmptyStateActionWrapper, Image } from "ui-widgets";

export const EmptyJSONConfiguration = () => {
  return (
    <EmptyStateActionWrapper
      title="No Custom Configurations"
      description={<>Add custom configurations by clicking on the plus button below.</>}
      illustrationGraphic={<Image className="image-style-A" src="/img/code.png" alt="Onestop Admin" />}
    />
  );
};
